import React from 'react';
import Carousel from './../carousel/Carousel';

const Image = () => {
	return (
		<div className="image__container">
			<Carousel />
			{/* <img
        className="hero__image"
        src="https://res.cloudinary.com/dydyt6wbt/image/upload/v1526386203/dental-care.jpg"
        alt=""
      /> */}
		</div>
	);
};

export default Image;



// WEBPACK FOOTER //
// ./src/components/main/Image.js